import _ from "lodash";
import listRequestWrapper from "../../../../../Services/API/listRequestWrapper";
import request from "../../../../../Services/API/Requests";
import {multiLanguageValue} from "../../../Utils/lib";
import asyncForEach from "../../../../../Utils/Form/FormDynamic/Utils/asyncForEach";

const getOperands = async () => {
    let operands = await listRequestWrapper('operand');
    return operands.map(i => {
        return {label: i.name, value: i.id, type: i.type}
    })
};
const setFilterValues = async (advancedFilter = [], columns, operands, setFilterLength, defaultValueType) => {
    let currentFilter = advancedFilter.slice();
    let currentFilterFront = [];
    if (advancedFilter && advancedFilter.length > 0) {
        //create filter with all helpers objects
        async function createFilterFront(advancedFilter, parent) {
            await asyncForEach(advancedFilter, async (filter) => {
                let nItem = null;
                if (filter['or']) {
                    nItem = {or: []}
                    await createFilterFront(filter['or'], nItem.or)
                }
                if (filter['and']) {
                    nItem = {and: []}
                    await createFilterFront(filter['and'], nItem.and)
                }
                let fullColumn = getColumnByName(filter.field, columns);
                let fullOperand = getOperandByName(filter.operand, operands);
                if (parent) {
                    if (filter.or) {
                        parent.push(nItem ? nItem : {
                            field: {
                                label: fullColumn.label,
                                value: filter.field,
                                type: fullColumn.type,
                                operands: fullColumn.operands,
                                entity: fullColumn.entity,
                                schema: fullColumn.entity ? await getSchema(fullColumn.entity) : undefined
                            },
                            operand: fullOperand,
                            value: filter.value,
                            value2: filter.value2 || '',
                            type: filter.type,
                        })
                        return
                    }

                    if (filter.and) {
                        parent.push(nItem ? nItem : {
                            field: {
                                label: fullColumn.label,
                                value: filter.field,
                                type: fullColumn.type,
                                operands: fullColumn.operands,
                                entity: fullColumn.entity,
                                schema: fullColumn.entity ? await getSchema(fullColumn.entity) : undefined
                            },
                            operand: fullOperand,
                            value: filter.value,
                            value2: filter.value2 || '',
                            type: filter.type,
                        })
                        return
                    }
                    console.log('valuetyp', defaultValueType)
                    parent.push({
                        field: {
                            label: fullColumn.label,
                            value: filter.field,
                            type: fullColumn.type,
                            operands: fullColumn.operands,
                            entity: fullColumn.entity,
                            schema: fullColumn.entity ? await getSchema(fullColumn.entity) : undefined
                        },
                        operand: fullOperand,
                        value: filter.value,
                        value2: filter.value2 || '',
                        type: filter.type || defaultValueType,
                    })
                    return
                }


                currentFilterFront.push(nItem ? nItem : {
                    field: {
                        label: fullColumn.label,
                        value: filter.field,
                        type: fullColumn.type,
                        operands: fullColumn.operands,
                        entity: fullColumn.entity,
                        predefinedRequired: fullColumn.required,
                        schema: fullColumn.entity ? await getSchema(fullColumn.entity) : undefined
                    },
                    operand: fullOperand,
                    value: filter.value,
                    value2: filter.value2 || '',
                    type: filter.type || defaultValueType,
                });
            })
        }

        await createFilterFront(advancedFilter);


        setFilterLength(1)
    }

    //set required filter
    for (const column of columns) {
        if (column.required && !_.find(advancedFilter, (e) => e.field === column.name)) {
            currentFilterFront.push({
                field: {
                    label: column.label,
                    value: column.name,
                    type: column.type,
                    operands: column.operands,
                    entity: column.entity,
                    schema: column.entity ? await getSchema(column.entity) : undefined,
                    predefinedRequired: column.required
                },
                operand: column.operands.length > 0 ? column.operands[0] : '',
                value: '',
                value2: '',
                type: defaultValueType
            });
            currentFilter.push({
                field: column.name,
                operand: column.operands.length > 0 ? column.operands[0].value : '',
                value: '',
                value2: ''
            });
            setFilterLength(1)
        }
    }

    //if filter is fill
    if (currentFilter.length === 0) {
        currentFilter = [{field: '', operand: '', value: ''}];
        currentFilterFront = [{field: {value: ""}, operand: {value: ""}, type: defaultValueType}];
    }
    return {currentFilter, currentFilterFront}
};
const setFilterColumns = async (operands, filterFields = [], columns = [], userLanguage, isAllColumns, persistentFilter) => {
    let columnsToFilter = [];
    if (filterFields && filterFields.length > 0) {
        for (const i of filterFields) {
            if (!_.isEmpty(i)) {
                columnsToFilter.push({
                    name: i.name,
                    label: i.label ? i.required ? `* ${multiLanguageValue(i.label, userLanguage)}` : i.label : i.name,
                    type: i.type,
                    required: i.required,
                    entity: i.entity,
                    operands: (!i.operands || i.operands.length === 0) ? operandsByType(operands, i.type) : getOperandsName(i.operands, operands)
                })
            }
        }
    } else {
        for (const i of columns) {

            if (isAllColumns) {
                columnsToFilter.push({
                    name: i.name,
                    label: i.label ? i.required ? `* ${i.label}` : i.label : i.name,
                    type: i.type,
                    required: i.required,
                    entity: i.entity,
                    operands: operandsByType(operands, i.type)
                })
                continue;
            }
            if (i.systemUsed) continue;

            //if custom column, skip
            if (i.calculable) continue;

            //if allColumns property is true, don't skip hidden columns
            if (!isAllColumns) {
                // if (i.hidden) continue;
            }

            //remove from filter fields list columns that in persistence filter
            if (persistentFilter && persistentFilter.length) {
                if (persistentFilter.find(v => v.field === i.name)) {
                    continue;
                }
            }
            columnsToFilter.push({
                name: i.name,
                label: i.label ? i.required ? `* ${i.label}` : i.label : i.name,
                type: i.type,
                required: i.required,
                entity: i.entity,
                operands: operandsByType(operands, i.type)
            })
        }
    }
    return columnsToFilter;
};
const checkForRequiredFields = (currentFilter, filterFields) => {
    const requiredColumns =
        _.filter(filterFields, (e) => e.required === true).map(e => {
            return {value: e.name, label: e.label}
        });
    const currentF = currentFilter.map(e => {
        return e.value && e.value.length > 0 && {value: e.field}
    });
    const dif = _.differenceBy(requiredColumns, currentF, 'value');
    if (dif.length > 0) {
        return dif
    } else {
        return false
    }
};
const isCustomShadowBox = (listStyles = {}) => {
    return listStyles.shadowBoxBlur || listStyles.shadowBoxHorizontal || listStyles.shadowBoxVertical || listStyles.shadowBoxSpread;
};
const defaultShadow = `0px 2px 1px -1px rgba(0,0,0,0.2), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 1px 3px 0px rgba(0,0,0,0.12)`;
export {
    getOperands,
    setFilterValues,
    setFilterColumns,
    checkForRequiredFields,
    isCustomShadowBox,
    defaultShadow
}

function operandsByType(operands, type) {
    let operandsByType = [];
    operands.forEach(op => {
        if (!op.type) {
            operandsByType.push(op)
        } else {
            op.type.forEach(t => {
                if (t === type.toUpperCase()) {
                    operandsByType.push(op)
                }
            })
        }
    });
    return operandsByType
}

function getOperandsName(value, operands) {
    let newValues = [];
    value.forEach(i => {
        if (typeof i === 'string') {
            newValues.push(_.find(operands, (o) => o.value === i))
        } else {
            newValues.push(i)
        }
    });

    return newValues;
}

function getOperandByName(name, operands) {
    let fullOperand = {};
    operands.forEach(o => {
        if (name === o.value) {
            fullOperand = o
        }
    });
    return fullOperand
}

function getColumnByName(name, columns = []) {
    let fullColumn = {};
    columns.forEach(c => {
        if (name === c.name) {
            fullColumn = c;
        }
    });

    return fullColumn;

}

async function getSchema(entity) {
    return await request({
        url: 'schema/read',
        method: 'POST',
        data: {id: entity}
    });
}